// src/layerInfoSidebar.js
import { getMap } from './mapInstance.js';
import { ownDataLayers } from './uploadModule.js';
import { updateBaseLegendMessage } from './mapUtils.js';


document.addEventListener('map-ready', () => {
  //initLayerSidebar(baseLayers, overlayLayers);
  initLayerSidebar();
});

// Layer containers
const layerPanel = document.getElementById('layer-info-panel');

// Group containers
const baseDataContainer = document.getElementById('base-data-layers');
const overlayContainer = document.getElementById('overlay-layers');
const ownDataContainer = document.getElementById('own-data-layers');

// Initialize sidebar
//export function initLayerSidebar(baseLayers = [], overlayLayers = []) {
export function initLayerSidebar() {
  const map = getMap();
  if (!map) {
    //console.warn('Layer sidebar init skipped: map not ready');
    return;
  }

    const allLayers = map.getLayers().getArray();

  const baseLayers = allLayers.filter(l => l.get('isBase'));
  const overlayLayers = allLayers.filter(l => l.get('isOverlay'));

  initLayerGroup(baseDataContainer, baseLayers);
  initLayerGroup(overlayContainer, overlayLayers);
  initLayerGroup(ownDataContainer, ownDataLayers, true);
}


// --- Generic function to initialize a layer group ---
function initLayerGroup(container, layers, isOwnData = false) {

    const map = getMap();
    if (!map) return;
  
  if (!container) return;
  container.innerHTML = ''; // clear previous entries

  layers.forEach((layer, index) => {
    const div = document.createElement('div');
    div.className = 'layer-item mb-2';

    // Checkbox toggle
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'form-check-input me-1';
    checkbox.id = `${container.id}-layer-${index}`;

    checkbox.checked = layer.getVisible();
    checkbox.addEventListener('change', () => {
      layer.setVisible(checkbox.checked);
    });

    // Label
    const label = document.createElement('label');
    label.className = 'form-check-label me-2';
    label.htmlFor = checkbox.id;
    label.textContent = layer.get('title') || `Layer ${index + 1}`;

    // Opacity slider
    const slider = document.createElement('input');
    slider.type = 'range';
    slider.min = 0;
    slider.max = 1;
    slider.step = 0.05;
    slider.value = layer.getOpacity() || 1;
    slider.className = 'form-range';
    slider.style.width = '100px';
    slider.addEventListener('input', () => layer.setOpacity(parseFloat(slider.value)));

    div.appendChild(checkbox);
    div.appendChild(label);
    div.appendChild(slider);
    container.appendChild(div);
  });
}

// --- Collapsible groups ---
document.querySelectorAll('.layer-group-header').forEach(header => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling;
    if (content) content.classList.toggle('d-none');
  });
});

// --- Dynamic update for Own Data layers ---
export function updateOwnDataSidebar() {
  initLayerGroup(ownDataContainer, ownDataLayers, true);
}

// --- Highlight a layer temporarily ---
export function highlightLayer(layer) {
  const highlightStyle = new ol.style.Style({
    stroke: new ol.style.Stroke({ color: '#FF8800', width: 3 }),
    fill: new ol.style.Fill({ color: 'rgba(255,136,0,0.2)' })
  });
  layer.setStyle(highlightStyle);
  setTimeout(() => layer.setStyle(null), 2000);
}

// Refresh Base Data group when base layers change
document.addEventListener('base-layers-updated', () => {
  const map = getMap();
  if (!map) return;

  const allLayers = map.getLayers().getArray();
  const baseLayers = allLayers.filter(l => l.get('isBase'));

  initLayerGroup(baseDataContainer, baseLayers);
  updateBaseLegendMessage(window.base_map);

});

